/* eslint-disable promise/param-names */
import Vue from 'vue'
import {
  ADD_NOTIFICATIONS,
  GET_NOTIFICATIONS
} from '../actions/notifications'
import axios from 'axios'

const state = {
  notifications: localStorage.getItem('notifications') || {},
  status: '',
  count: 0
}

const getters = {
  hasNotifications: state => !!state.notifications,
  NotificationsStatus: state => state.status,
  getNotifications: state => state.notifications,
  getNotificationsCount: state => state.count
}

const actions = {

  [ADD_NOTIFICATIONS]: ({
    commit,
    dispatch
  }, value) => {
    return new Promise((resolve, reject) => {
      commit(ADD_NOTIFICATIONS, value)
      //localStorage.removeItem('user-token')
      resolve()
    })
  },
  [GET_NOTIFICATIONS]: ({
    commit,
    dispatch
  }) => {
    return new Promise((resolve, reject) => {
      resolve()
    })
  },

}

const mutations = {

  [ADD_NOTIFICATIONS]: (state, value) => {
    var notf = state.notifications
    var size = 0,
      key;
    for (key in notf) {
      if (notf.hasOwnProperty(key)) size++;
    }
    notf[size] = value 
    // /notf = notf.slice().reverse();
    Vue.set(state, 'count', size+1)
    state.notifications = Object.assign({}, state.notifications, notf)

  }

}

export default {
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/notifications.js